import { NavLink, Outlet, useLocation } from "react-router-dom";
import { cn } from "@/lib/utils";
import { LayoutDashboard, PieChart, List, Repeat, CalendarDays, Target, Scale, Wand2, BookOpen } from "lucide-react";

const TABS = [
  { to: "/money", label: "Overview",     icon: LayoutDashboard, testId: "money-nav-overview", end: true },
  { to: "/money/budgets", label: "Budgets", icon: PieChart,     testId: "money-nav-budgets" },
  { to: "/money/bills", label: "Bills calendar", icon: CalendarDays, testId: "money-nav-bills" },
  { to: "/money/goals", label: "Goals",   icon: Target,        testId: "money-nav-goals" },
  { to: "/money/transactions", label: "Transactions", icon: List, testId: "money-nav-transactions" },
  { to: "/money/recurring", label: "Recurring", icon: Repeat,  testId: "money-nav-recurring" },
  { to: "/money/rules", label: "Rules", icon: Wand2, testId: "money-nav-rules" },
  { to: "/money/reconciliation", label: "Reconcile", icon: Scale, testId: "money-nav-reconciliation" },
  { to: "/money/ledger", label: "Ledger", icon: BookOpen, testId: "money-nav-ledger" },
];

export default function MoneyLayout() {
  return (
    <div className="animate-fade-in-up">
      <div className="mb-6 flex items-center justify-between">
        <div>
          <h2 className="text-2xl md:text-3xl font-medium text-surface-on tracking-tight">Money</h2>
          <p className="text-sm text-surface-onVariant mt-1">Your finance hub — accounts, budgets and cashflow.</p>
        </div>
      </div>
      <div className="mb-6 inline-flex items-center gap-1 rounded-full bg-surface-container p-1">
        {TABS.map(({ to, label, icon: Icon, testId, end }) => (
          <NavLink
            key={to} to={to} end={end}
            data-testid={testId}
            className={({ isActive }) => cn(
              "inline-flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium transition-colors duration-200 ease-md",
              isActive ? "bg-primary text-primary-foreground" : "text-surface-on hover:bg-primary/8"
            )}
          >
            <Icon className="w-4 h-4" />
            {label}
          </NavLink>
        ))}
      </div>
      <Outlet />
    </div>
  );
}
